module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFilePopupClick()
      }
    }
  }, [_vm._v("Upload File")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 col-lg-12"
  }, [_c('vue-good-table', {
    attrs: {
      "mode": "remote",
      "styleClass": "vgt-table good-table condensed striped",
      "columns": _vm.columns,
      "rows": _vm.fileData,
      "totalRows": _vm.fileDataCount,
      "pagination-options": {
        enabled: true,
        perPage: 15,
        perPageDropdown: [10, 15, 20, 50, 100]
      }
    },
    on: {
      "on-page-change": _vm.onPageChange,
      "on-sort-change": _vm.onSortChange,
      "on-column-filter": _vm.onColumnFilter,
      "on-per-page-change": _vm.onPerPageChange
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [_vm._t("default", null, {
          "props": props
        }), _vm._v(" "), (props.column.field == 'created_at') ? _c('span', [_vm._v("\n                    " + _vm._s(_vm.formatDate(props.formattedRow[props.column.field], 'd/M/Y hh:ss')) + "\n                  ")]) : (props.column.field == 'view') ? _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showDownloadColumn),
            expression: "showDownloadColumn"
          }],
          attrs: {
            "id": "download-link"
          },
          on: {
            "click": function($event) {
              return _vm.downloadFile(props.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-download",
          attrs: {
            "aria-hidden": "true"
          }
        })]) : _c('span', [_vm._v(_vm._s(props.formattedRow[props.column.field]))])]
      }
    }], null, true)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_c('nv-empty-state', {
    attrs: {
      "icon": "fa-folder-open-o",
      "title": "No files found",
      "hint": "Uploaded files will show up here."
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "loadingContent"
  })], 2)], 1)])])]), _vm._v(" "), (_vm.showUploadFileModel) ? _c('div', {
    staticClass: "modal-backdrop",
    attrs: {
      "id": "upload"
    }
  }, [_c('div', {
    staticClass: "modal modal-md",
    staticStyle: {
      "height": "200px",
      "max-width": "800px"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_c('h3', [_vm._v("Upload File")])]
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0px 20px",
      "overflow-y": "auto",
      "overflow-x": "hidden",
      "height": "100%"
    }
  }, [_vm._t("body", function() {
    return [_c('div', {
      staticClass: "form-horizontal"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-4 control-label radio-inline required",
      staticStyle: {
        "font-weight": "500"
      },
      attrs: {
        "for": "campaign"
      }
    }, [_vm._v("Upload file")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-8",
      staticStyle: {
        "margin-top": "7px"
      }
    }, [_c('div', [_c('input', {
      attrs: {
        "type": "file",
        "id": "csvFile",
        "accept": ".gpg,.xlsx,.xls,.csv"
      },
      on: {
        "change": _vm.onFileChange
      }
    })])])])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "margin-top": "auto",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "form-group pull-right"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeUploadModel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.proceedUploadModel
    }
  }, [_vm._v("Upload")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7a1ae868","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/file-upload/uploadTable.vue
// module id = +ejG
// module chunks = 1